import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "qms-display" }
const _hoisted_2 = { class: "headerzz" }
const _hoisted_3 = { class: "header-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "counter-grid" }
const _hoisted_6 = { class: "counter-label" }
const _hoisted_7 = { class: "counter-number" }

import store from '@/store';
import { QueueNumber } from '@/store/enums/StoreEnums';
import { subscribe, unsubscribe } from '@/websocket/stompService';
import { TOPICS } from '@/websocket/topics';
import { onMounted, onUnmounted, ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BoothCount',
  setup(__props) {

const counters = ref([]);

  const loadFirstData = async () => {
    const data = await store.dispatch(QueueNumber.getProcessingQueueList, {});
    if(data.code == 200 && data.data) {
      counters.value = data.data;
    }
  }

  const refreshData = (data) => {
    counters.value = JSON.parse(data.body);
  }

  onMounted( async () => {
    loadFirstData();
    subscribe(TOPICS.NOTIFY, refreshData);
  });

  onUnmounted(() => {
    unsubscribe(TOPICS.NOTIFY, refreshData);
  });
  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          alt: "Logo",
          src: require(`@/assets/logo.png`)
        }, null, 8, _hoisted_4)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "header-text" }, "AN TOÀN THỰC PHẨM HẢI PHÒNG 24/7", -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(counters.value, (counter) => {
        return (_openBlock(), _createElementBlock("div", {
          key: counter.n_ma_quay,
          class: "counter-box"
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(counter.cTenQuay), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(counter.cSoThuTu ? counter.cSoThuTu : ""), 1)
        ]))
      }), 128))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer" }, [
      _createElementVNode("div", { class: "footer-marquee-outer" }, [
        _createElementVNode("div", { class: "footer-marquee-inner" }, [
          _createElementVNode("span", { class: "marquee-text" }, "Thời gian tiếp: Sáng từ 8:00-11:30, Chiều từ 13:30-17:00    ")
        ])
      ])
    ], -1))
  ]))
}
}

})